import { Alert, SxProps, Theme } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

interface Props {
    /** Nudge copy — a short sentence explaining what's gated and how to unlock it. */
    message: React.ReactNode;
    sx?: SxProps<Theme>;
}

/**
 * Shared "upgrade to unlock this" inline nudge. Originally inline in DashboardBoard for the
 * premium owner-dashboard hint; extracted so every plan-tier upsell surface (premium dashboard,
 * free-tier seat/module caps, ...) renders the same nudge instead of each growing its own.
 */
export default function UpgradeNudge({ message, sx }: Props) {
    return (
        <Alert icon={<WorkspacePremiumIcon fontSize="inherit" />} severity="info" sx={sx}>
            {message}
        </Alert>
    );
}
